




























import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { biBrow } from '@tencent/fit-bi-sdk';
import TopBanner from '@/components/home/top-banner/index.vue';
import MyCouponStamp from '@/components/home/my-coupon-stamp/index.vue';
import MidBanner from '@/components/home/mid-banner/index.vue';
import NewGuide from '@/components/home/new-guide/index.vue';
import Wecoupons from './WeCoupons/index.vue';
import DiscountCodeModule from '@/components/discount-code/v2.vue';
import { language, url } from '@tencent/ppd-base-libs';
import LargeMiniBannerModule from '@/components/home-newest/large-mini-banner/index.vue';
import { checkIsInSpring } from '@/business/spring';
import { customDocumentTitle, defaultDocumentTitle } from '../config/document-title';
import AppleHubCard from '@/components/apple-hub-card/index.vue';
import { userEnv } from '@tencent/wphk-base-utils';

export default defineComponent({
  name: 'Home',
  components: {
    TopBanner,
    MyCouponStamp,
    MidBanner,
    Wecoupons,
    DiscountCodeModule,
    NewGuide,
    LargeMiniBannerModule,
    AppleHubCard,
  },
  setup() {
    const lang = language.getLanguage();
    document.title = customDocumentTitle[url.getParamAdtag()] || defaultDocumentTitle;
    // 判断是否在spring
    const isInSpring = checkIsInSpring();
    const showAppleHubCard = userEnv.getOSInfoObj().type === 'iphone';

    const noTopBanner = ref('');
    // 我的优惠券模块实例引用，用于领券成功后刷新数量
    const myCouponStamp = ref<{ refresh: () => void } | null>(null);
    // 是否渲染新人引导模块
    const renderNewGuideModule = ref(false);
    onMounted(() => {
      // 这个埋点B.C与很多页面重复，无法在该字段上增加拓展字段
      biBrow('home.page_brow');
      // 同时为了向前兼容，避免老埋点丢失。因此新增一个页面曝光埋点
      biBrow('discount-center-home.page_brow', {
        fminiprogram: userEnv.getMiniProgramAppId(),
      });
    });
    return {
      emptyData() {
        noTopBanner.value = 'no-top-banner';
      },
      lang,
      isInSpring,
      showAppleHubCard,
      noTopBanner,
      myCouponStamp,
      // 领券成功后刷新"我的优惠券"数量
      refreshMyCouponStamp() {
        myCouponStamp.value?.refresh();
      },
      renderNewGuideModule,
      // 巨幕banner结束后在展示新人引导
      largeBannerComplete() {
        renderNewGuideModule.value = true;
      },
    };
  },
});
